import { GET_NOTES } from "constants/notes";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_NOTES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
